import { render, staticRenderFns } from "./addemployee.vue?vue&type=template&id=2c8f205e&scoped=true"
import script from "./addemployee.vue?vue&type=script&lang=js"
export * from "./addemployee.vue?vue&type=script&lang=js"
import style0 from "./addemployee.vue?vue&type=style&index=0&id=2c8f205e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8f205e",
  null
  
)

export default component.exports